import { useRef } from "react";
import { Box, Button } from "@common-ui/ui";
import AssetCards from "./AssetCards";
import CustomerCard from "./CustomerCard";
import OrgCard from "./OrgCard";
import { useReactToPrint } from "../../utils/handlePrint";

const SummaryDownload = (props) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `summary-report`,
  });
  return (
    <>
      {props.combined ? (
        ""
      ) : (
        // <Container maxWidth="lg">
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            // onClick={generatePDF}
            onClick={handlePrint}
            type="button"
          >
            Export PDF
          </Button>
        </Box>
        // </Container>
      )}
      <div ref={componentRef}>
        {" "}
        <OrgCard {...props} />
        <CustomerCard {...props} />
        <AssetCards {...props} />
      </div>
    </>
  );
};

export default SummaryDownload;
